
import { ASSETS_API_URL } from "config/api";
import { showApiError } from "config/apiToast";
import { getApiErrorMessages } from "config/apiErrors";
import { trimDecimal } from "./marketFields";
import { Modal, Nav, Pagination } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import { RemoveShoppingCartOutlined } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
const Pairs = () => {
    const [tasks, setTasks] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [itemsPerPage] = useState(10); // Set the limit per page
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState("");

    const getData = async (page, limit) => {
        const tok = localStorage.getItem("accessTokenDash");
        setTasks([]);
        setLoading(true);
        setLoadError("");

        var config = {
            method: "get",
            url: `${ASSETS_API_URL}/pairs?page=${page}&limit=${limit}`,
            headers: {
                authorization: `Bearer ${tok}`
            },
        };

        axios(config)
            .then(function (response) {
                setTasks(response?.data?.data || []); // Assuming the tasks array is nested inside data
                setTotalPages(response?.data?.pagination?.pageCount || 1); // Assuming the total page count is returned
            })
            .catch(function (error) {
                console.error("Error fetching data:", error);
                setLoadError(getApiErrorMessages(error).join(" "));
            })
            .finally(function () {
                setLoading(false);
            });
    };


    const deleteToken = async (id) => {
        console.log(id)
        const tok = localStorage.getItem("accessTokenDash");
        // setTasks([]);

        var config = {
            method: "delete",
            url: `${ASSETS_API_URL}/markets/${id}`,
            headers: {
                authorization: `Bearer ${tok}`
            },
        };

        axios(config)
            .then(function (response) {
                console.log("responce", response)
                getData(currentPage, itemsPerPage);
                // setTasks(response?.data?.data); // Assuming the tasks array is nested inside data
                // setTotalPages(response?.data?.pagination?.pageCount); // Assuming the total page count is returned
            })
            .catch(function (error) {
              console.error("Error fetching data:", error);
              showApiError(error);
            });
    };


    useEffect(() => {
        getData(currentPage, itemsPerPage);
    }, [currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    return (
        <>
            <img className='elipse img-fluid' src='/assets/main-assets/Ellipse.png' alt="ellipse" />
            <div className="content">

                <div className="tokenicon">
                    <div className="maintablea_task">
                        <div class="table-responsive  maintable">
                            <table>
                                <thead>
                                    <th>Pair Symbol </th>
                                    <th>Base</th>
                                    <th>Quote</th>
                                    <th>Min Order Amount</th>
                                    <th>Enabled</th>
                                    <th>Details</th>
                                </thead>
                                <tbody>
                                    {loading && (
                                        <tr><td colSpan="6"><p className="white">Loading pairs...</p></td></tr>
                                    )}
                                    {!loading && loadError && (
                                        <tr><td colSpan="6"><p className="error">{loadError}</p></td></tr>
                                    )}
                                    {!loading && !loadError && tasks?.length === 0 && (
                                        <tr><td colSpan="6"><p className="white">No pairs found.</p></td></tr>
                                    )}
                                    {tasks?.map((task, index) => (
                                        <tr key={index}>
                                            <td>
                                                <p className="white dfgtrhgwrgreg">{task?.symbol}</p>
                                            </td>
                                            <td >
                                                <p className="white dfgtrhgwrgreg"> <img className='elipse img-fluid' src={task?.baseIcon} alt="ellipse" class="sdsdsdvdwerfacs" />{task?.base}</p>
                                            </td>
                                            <td>
                                                <p className="white dfgtrhgwrgreg"> <img className='elipse img-fluid' src={task?.quoteIcon} alt="ellipse" class="sdsdsdvdwerfacs" />{task?.quote}</p>
                                            </td>
                                            <td>
                                                <p className="white dfgtrhgwrgreg">  {task?.tradingConfig?.minTradeAmount ? trimDecimal(task.tradingConfig.minTradeAmount) : "-"}</p>
                                            </td>
                                            <td>
                                                {task?.isActive === true ?
                                                    (
                                                        <button className="yes">Yes</button>
                                                    )
                                                    :
                                                    (
                                                        <button className="no">No</button>
                                                    )
                                                }
                                            </td>
                                            <td>
                                                <Link to={`pairdetails?ids=${task?.id}`}>
                                                    <button type="button" className="dettailsbut">Details</button>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            <div className="Paginationlattable">
                                <div>
                                    <p className="showclasss">
                                        SHOWING {(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, tasks.length)} OF {tasks.length}
                                    </p>
                                </div>
                                <div className="pagitwo">
                                    <button className="leftpigbtn" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15"
                                            height="15"
                                            viewBox="0 0 15 15"
                                            fill="none"
                                        >
                                            <path
                                                d="M10 13L5 8L10 3"
                                                stroke="#565656"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </button>
                                    <Pagination>
                                        {Array.from({ length: totalPages }, (_, index) => (
                                            <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
                                                {index + 1}
                                            </Pagination.Item>
                                        ))}
                                    </Pagination>
                                    <button className="leftpigbtnn" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15"
                                            height="15"
                                            viewBox="0 0 15 15"
                                            fill="none"
                                        >
                                            <path
                                                d="M5 13L10 8L5 3"
                                                stroke="#565656"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Pairs
